module.exports = __webpack_public_path__ + "img/drop-down.fd6f2bc1.svg";